import { Component, Input, OnInit, inject, DestroyRef } from '@angular/core';
import { Router } from '@angular/router';
import { RouterSegments } from 'src/app/models/router-segments';
import { ServiceCardInfo } from 'src/app/models/service/service-card-info';
import { ServiceStatus } from 'src/app/models/service/service-status';
import { AuthService } from 'src/app/services/auth/auth.service';
import { TrialStatusService } from 'src/app/services/util/trial-status.service';
import { Constants } from 'src/app/models/constants';
import { TenantsService } from 'src/app/services/api/tenants.service';
import {SolutionVersionsInfo} from 'src/app/models/service/solution-versions-info';
import { SolutionVersionsService } from 'src/app/services/util/solution-versions.service';
import { BlueprintsService } from 'src/app/services/api/blueprints.service';
import { ToastrService } from 'src/app/services/util/toastr.service';
import { DeploymentClass } from 'src/app/models/instance-class';
import { translate } from '@jsverse/transloco';
import { SolutionsService } from 'src/app/services/api/solutions.service';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
@Component({
    selector: 'app-byob-service-card',
    templateUrl: './byob-service-card.component.html',
    styleUrls: ['./byob-service-card.component.scss'],
    standalone: false
})
export class ByobServiceCardComponent implements OnInit {
  private destroyRef = inject(DestroyRef);
  @Input() serviceCardInfo: ServiceCardInfo;
  @Input() loader: boolean;
  ServiceStatus = ServiceStatus;
  trialStatus: string;
  region: any;
  versionInfo: any;
  capabilities: any;
  releaseVersion: any;
  releaseVersionText: any;
  isAMR= false;
  isSandbox: boolean;
  serviceVersionsInfo: SolutionVersionsInfo;
  serviceVersions: any;
  latestReleaseVersion: any;
  tenant: string;

  Constants = Constants;

  readonly statusInfo: { [key: string]: any } = {
    [ServiceStatus.LIVE]: {icon: 'done', colorClass: 'green-1-bg'},
    [ServiceStatus.IN_PROGRESS]: {icon: 'change_circle', colorClass: 'accent-1-bg'},
    [ServiceStatus.DOWN]: {icon: 'info', colorClass: 'warn-solid-bg'},
  };

  constructor(private router: Router, private authService: AuthService, private trialStatusService: TrialStatusService,
    private tenantsService: TenantsService, private solutionVersionsService: SolutionVersionsService,
    private blueprintsService: BlueprintsService, private toastrService: ToastrService, private solutionsService: SolutionsService) {
	}

  ngOnInit(): void {
    if(!this.loader) {
    this.versionInfo = this.serviceCardInfo?.serviceVersionsInfo?.devVersion?.version ?
    this.serviceCardInfo?.serviceVersionsInfo?.devVersion?.version : this.serviceCardInfo?.buildNumber;
    const serviceId = this.serviceCardInfo?.blueprint?.solutionId;
    //   this.solutionsService.getSolutionVersions(serviceId).pipe(takeUntilDestroyed(this.destroyRef))
    //   .subscribe((result: any) => {
    //   this.serviceVersions = result;
    //   const liveInstance = this.serviceCardInfo.instances.find(instance => instance.deploymentClass === DeploymentClass.A);
    //   if (liveInstance) {
    //     this.latestReleaseVersion = this.serviceVersions?.filter(version =>
    //       version.id === liveInstance.solutionVersionId)[0]?.releaseVersion;
    //   } else {
    //     const instanceLength = this.serviceCardInfo.instances.length;
    //     const latestInstanceSolutionVersion = this.serviceCardInfo.instances[instanceLength - 1]?.solutionVersionId;
    //     this.latestReleaseVersion = this.serviceVersions?.filter(version =>
    //       version.id === latestInstanceSolutionVersion)[0]?.releaseVersion;
    //   }
    //   if (this.latestReleaseVersion) {
    //     this.releaseVersion = this.latestReleaseVersion;
    //     this.releaseVersionText = this.releaseVersion;
    //   } else {
    //     this.releaseVersion = this.serviceCardInfo?.serviceVersionsInfo?.currentVersion?.releaseVersion;
    //     this.releaseVersionText = this.releaseVersion;
    //   }
    //   if(this.solutionVersionsService.releaseVersion(this.releaseVersionText)) {
    //     this.isAMR = true;
    //   }
    // });
    const demoInstance = this.serviceCardInfo.instances?.find((instance) => instance.blueprintId === this.serviceCardInfo.blueprint.id);
    // this.region = demoInstance?.region ? demoInstance?.region : this.getTenantDetails();
    if(demoInstance && this.serviceCardInfo.blueprint.demo) {
      this.trialStatus = this.trialStatusService.deployStatusUTCFormat(demoInstance);
    } else {
      this.trialStatus = this.trialStatusService.createdStatusUTCFormat(this.serviceCardInfo?.blueprint);
    }

    // this.getLatestVersion(this.serviceCardInfo);

    if (this.serviceCardInfo.status === ServiceStatus.LIVE) {
      this.loadBlueprintVersion(this.serviceCardInfo.blueprint.id);
    }
  }
  this.tenant = this.authService.principal.provider;
  }

  getLatestVersion(card): void {
    this.blueprintsService.getBlueprintsIdLatestVersion(card.blueprint.id)
      .pipe(takeUntilDestroyed(this.destroyRef))
      .subscribe(result => {
          this.serviceCardInfo.latestVersion = result;
          this.capabilities = this.serviceCardInfo?.latestVersion?.capabilities?.length;
      }, (error) => {
        this.toastrService.clear();
            setTimeout(() => {
		  const title = translate('ERRORS.SERVICE_AVAILABILITY');
          const message = error?.message ? error?.message : (error?.error?.message ? error?.error?.message : (error?.errmsg ? error?.errmsg : translate('SERVICE.INTERNAL_SERVER_ERROR')));
          this.toastrService.errMessage(message, title);
        }, 500);
      });
  }

  loadBlueprintVersion(id: string): void {
    this.blueprintsService.getBlueprintVersion(id)
      .pipe(takeUntilDestroyed(this.destroyRef))
      .subscribe((result: any) => {
        const liveInstanceId = this.serviceCardInfo.blueprint?.pathToLiveConfiguration?.
          find(item => item.deploymentClass === DeploymentClass.A)?.instanceId;
        const blueprintVersionId = this.serviceCardInfo.instances.find(item => item.id === liveInstanceId)?.blueprintVersionId;
        this.serviceCardInfo.serviceDefinitionVersion = result?.find(item => item.id === blueprintVersionId)?.version;
      }, (error) => {
        this.toastrService.clear();
            setTimeout(() => {
		  const title = translate('ERRORS.SERVICE_AVAILABILITY');
          const message = error?.message ? error?.message : (error?.error?.message ? error?.error?.message : (error?.errmsg ? error?.errmsg : translate('SERVICE.INTERNAL_SERVER_ERROR')));
          this.toastrService.errMessage(message, title);
        }, 500);
      });
  }

  goToBlueprintSummary(): void {
    this.router.navigate(['/', this.authService.principal.provider, RouterSegments.SERVICES, this.serviceCardInfo.service.id,
    RouterSegments.BLUEPRINTS, this.serviceCardInfo.blueprint.id]);
  }

  getTenantDetails(): void {
    this.tenantsService.getTenantDetails()
		.pipe(takeUntilDestroyed(this.destroyRef))
    .subscribe(tenantData => {
      this.region = tenantData?.temenosRegion;
    });
  }

}
